'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;
var inputs = void 0;
var fileInputs = void 0;

function init() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    inputs = context.querySelectorAll('.js-input-group');
    inputs = Array.prototype.slice.call(inputs);

    fileInputs = document.querySelectorAll('.js-file-input');
    fileInputs = Array.prototype.slice.call(fileInputs);

    var file = document.getElementsByClassName("file");
    for (var i = 1; i < file.length; i++) {
        file[i].closest('div').style.display = "none";
    }

    setupInitialState();
    addEventListeners();
}
window.inputGroup = init;

function setupInitialState() {
    inputs.forEach(function (element) {
        if (!element.value) {
            element.classList.remove('input-focus');
        } else if (!element.classList.contains('input-focus')) {
            element.classList.add('input-focus');
        }
    });
}

function addEventListeners() {
    inputs.forEach(function (element) {
        element.addEventListener('focus', handleFocus);
        element.addEventListener('blur', handleBlur);
    });

    fileInputs.forEach(function (element) {
        element.addEventListener('change', updateFileInput);
    });
}

function handleFocus(evt) {
    if (!evt.target.classList.contains('js-input-group')) {
        return;
    }
    evt.target.classList.add('input-focus');
}

function handleBlur(evt) {
    if (!evt.target.classList.contains('js-input-group')) {
        return;
    }
    if (!evt.target.value) {
        evt.target.classList.remove('input-focus');
    }
}

function updateFileInput(evt) {
    if (!evt.target.classList.contains('js-file-input')) {
        return;
    }

    var label = evt.target.nextElementSibling;
    var fileName = '';

    if (evt.target.files && evt.target.files.length > 1) {
        fileName = (evt.target.getAttribute('data-multiple-caption') || '').replace('{count}', evt.target.files.length);
    } else {
        fileName = evt.target.value.split('\\').pop();

        if (fileName) {
            label.querySelector('span.file').innerHTML = fileName;
            label.classList.add('input-focus');
        } else {
            label.querySelector('span.file').innerHTML = '';
            label.classList.remove('input-focus');
        }
    }
    var isHidden = function isHidden(elem) {
        var styles = window.getComputedStyle(elem);
        return styles.display === 'none' || styles.visibility === 'hidden';
    };

    var file = document.getElementsByClassName("file");
    for (var i = 0; i < file.length; i++) {
        if (isHidden(file[i].closest('div'))) {
            file[i].closest('div').style.display = "block";
            break;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/form/input-group.js
// module id = ./resources/assets/js/src/form/input-group.js
// module chunks = 0